<app-header [forceLightBackground]="true"></app-header>
<section class="privacy-policy" #scrollContainer (scroll)="onScroll()">

	<div class="privacy-policy__content--container">
		<div class="privacy-policy__content">
			<h5 class="privacy-policy__title privacy-policy__title--mobile">
				Terms of Service
			</h5>
			<p class="privacy-policy__search--title privacy-policy__search--title--mobile">
				Select section to view
			</p>

			<div
				[class.sticky-dropdown]="isStickyDropdown"
				class="dropdown-container dropdown-container--mobile"
			>
				<select
					class="form-select"
					[(ngModel)]="selectedItem"
					(change)="onDropdownChange($event)"
				>
					<option *ngFor="let category of categories" [value]="category.label">
						{{ category.label }}
					</option>
				</select>
			</div>
			<!-- Iterate over sections and display -->
			<div
				*ngFor="let section of sections"
				class="privacy-policy__section scroll-offset-anchor"
				[attr.id]="sanitizeId(section.label)"
			>
				<div class="privacy-policy__header">
					<span class="privacy-policy__label"
						>{{ section?.serialNumber }}.</span
					>
					<span class="privacy-policy__label"
						>{{ section?.label }}</span
					>
				</div>
				<div *ngIf="section.description && section.description.length">
					<!-- If only one point, show as paragraph aligned with label, no serial number -->
					<ng-container *ngIf="section.description.length === 1; else multiplePoints">
						<div class="privacy-policy__single-point">
							<span class="privacy-policy-decription" [innerHTML]="section.description[0].text"></span>
						</div>
					</ng-container>
					<ng-template #multiplePoints>
						<ng-container *ngFor="let point of section.description">
							<div class="privacy-policy__point">
								<span class="privacy-policy__point-number">{{ point.serialNumber }}</span>
								<span class="privacy-policy-decription" [innerHTML]="point.text"></span>
							</div>
							<ng-container *ngIf="point.children && point.children.length">
								<ng-container *ngFor="let sub of point.children">
									<div class="privacy-policy__subpoint">
										<span class="privacy-policy__subpoint-letter">({{ sub.serialNumber }})</span>
										<span class="privacy-policy-decription" [innerHTML]="sub.text"></span>
									</div>
									<ng-container *ngIf="sub.children && sub.children.length">
										<div class="privacy-policy__subsubpoint" *ngFor="let subsub of sub.children">
											<span class="privacy-policy__subsubpoint-roman">{{ subsub.serialNumber }}</span>
											<span class="privacy-policy-decription" [innerHTML]="subsub.text"></span>
										</div>
									</ng-container>
								</ng-container>
							</ng-container>
						</ng-container>
					</ng-template>
				</div>
			</div>
		</div>

		<!-- Right side sticky category nav (visible on xl and xxl devices only) -->
		<nav class="view--section__categories view--section__categories--desktop">
			<div class="view--section__heading-wrapper">
				<span class="view--section__heading">Select section to view</span>
			</div>
			<div class="view--section__categories--scroll">
				<button
					class="view--section__category-btn"
					*ngFor="let category of categories"
					(click)="filterSections(category.label)"
					[class.view--section__category-btn--active]="activeCategory === category.label"
				>
					{{ category.label }}
				</button>
			</div>
		</nav>
	</div>
	<app-footer></app-footer>
</section>
